export default function createRealtime(enabled, createEcho) {
    const observers = [];
    let status = enabled ? 'connecting' : 'disabled';
    let echo;

    function updateStatus(next) {
        status = next;
        observers.forEach(observer => observer(status));
    }

    if (enabled) {
        echo = createEcho();
        const connection = echo.connector.pusher.connection;
        const state = current => current === 'connected' ? 'connected'
            : current === 'connecting' ? 'connecting' : 'disconnected';
        connection.bind('state_change', ({ current }) => updateStatus(state(current)));
        connection.bind('error', () => updateStatus('disconnected'));
        status = state(connection.state);
    }

    return {
        subscribe(channel, listeners, privateChannel = false) {
            if (!enabled) return;
            const subscription = privateChannel ? echo.private(channel) : echo.channel(channel);
            Object.keys(listeners).forEach(event => subscription.listen(event, listeners[event]));
        },
        onStatus(observer) {
            observers.push(observer);
            observer(status);
        }
    };
};
